import React from 'react';
import { FDAlert } from '@facet-wealth/design';
import Proptypes from 'prop-types';


// This is intended to be used as a single-line alert which shows a brief error message
const InlineErrorAlert = ({ value }) => {
  return value !== '' ? <FDAlert status={'error'} title={value} /> : null;
};

InlineErrorAlert.propTypes = {
  value: Proptypes.string.isRequired,
};

export { InlineErrorAlert };
